import { render, staticRenderFns } from "./ImageOption.vue?vue&type=template&id=09512090&scoped=true"
import script from "./ImageOption.vue?vue&type=script&lang=ts"
export * from "./ImageOption.vue?vue&type=script&lang=ts"
import style0 from "./ImageOption.vue?vue&type=style&index=0&id=09512090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09512090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VDialog,VIcon})
